import { render } from "./CheckOrExclamationTriangle.vue?vue&type=template&id=2348670c"
import script from "./CheckOrExclamationTriangle.vue?vue&type=script&lang=js"
export * from "./CheckOrExclamationTriangle.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__